import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { AprService } from 'app/modules/annulus-pressure-record/services/annulus-pressure-record.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EMPTY, map, merge, Subject, switchMap, takeUntil } from 'rxjs';
import { saveAs } from 'file-saver';
import { AprHistoricalDataModalComponent } from 'app/modules/annulus-pressure-record/components/historical-data-modal/historical-data-modal.component';
import module from "app/modules/annulus-pressure-record/annulus-pressure-record.module";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-historical-pi-data-modal',
  templateUrl: './historical-pi-data-modal.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./historical-pi-data-modal.component.scss']
})
export class AprPiHistoricalDataModalComponent {
  @ViewChild(MatPaginator) private _paginator: MatPaginator;
  @ViewChild(MatSort) private _sort: MatSort;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  public aprHistroicalRecord$ = this.aprService.aprHistroicalRecord$

  public filterData = {
    pageNumber: 1,
    pageSize: 10,
    wellName: '',
    reportType: '',
    startDate: null,// new Date(),
    endDate: null
  }

  searchForm: UntypedFormGroup;
  dt: any//Datatable<any>;
  startingIndex: number = 0
  isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AprHistoricalDataModalComponent>,
    @Inject(MAT_DIALOG_DATA) public wellDetails: any,
    public dialog: MatDialog,
    private aprService: AprService,
    private _formBuilder: UntypedFormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.setSearch();
    this.setDataTable();
    this.setPage({ offset: 0 });
  }

  ngAfterViewInit() {
    if (this._sort && this._paginator) {
      // Set the initial sort
      this._sort.sort({
        id: 'field',
        start: 'asc',
        disableClear: true,
      });

      // Mark for check
      this._changeDetectorRef.markForCheck();

      // If the user changes the sort order...
      this._sort.sortChange
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(() => {
          // Reset back to the first page
          this._paginator.pageIndex = 0;

          this.onSort(this._sort)
        });


      // Get platform types if sort or page changes
      merge(this._sort.sortChange, this._paginator.page).pipe(
        switchMap(() => {
          // this.isLoading = true;

          this.startingIndex = this._paginator.pageIndex * this._paginator.pageSize;

          let pageInfo = {
            'count': this._paginator.length,
            'pageSize': this._paginator.pageSize,
            'limit': this._paginator.pageSize,
            'offset': this._paginator.pageIndex
          }
          this.setPage(pageInfo); // Emit page number

          return EMPTY
        }),
        map(() => {
          this.isLoading = false;
        }),
      ).subscribe();
    }
  }

  setSearch() {
    this.searchForm = this._formBuilder.group({
      Page: [0],
      PageSize: [10],
      OrderBy: [null],
      OrderDir: [null],
      WellName: [''],
      PlatformName: [''],
      StringName: [''],
      FieldName: [''],
      id: null
    });

    this.searchForm.get('PageSize').valueChanges.subscribe(value => this.setSize(value));
  }

  setSize(size: number) {
    this.dt.page.size = size;
    this.dt.page.offset = 0
    this.setPage({ offset: this.dt.page.offset });
  }

  setPage(pageInfo) {
    this.dt.page.offset = pageInfo.offset;
    this.startingIndex = this.dt.page.offset * this.dt.page.size

    this.searchForm.patchValue({
      Page: this.dt.page.offset + 1,
      id: this.wellDetails.wellStringId
    });

    this.aprService
      .getHistoricalPiData(this.searchForm.value)
      .subscribe((pagedData) => {
        this.dt.page.totalPages = pagedData.data.totalPages;
        this.dt.page.totalRecords = pagedData.data.totalRecords;
        this.dt.rows = pagedData.data.data;
      });
  }

  setDataTable() {
    this.dt = {
      page: {
        size: this.searchForm.get('PageSize')?.value,
        totalRecords: 0,
        totalPages: 0,
        offset: 0,
      },
      rows: [],
    };
  }

  downloadHistoricalApr() {
    this.aprService.downloadHistoricalApr(this.wellDetails.wellStringId).subscribe((res) => {
      saveAs(res, 'Annulus Pressure Historical Records');
    })
  }

  handleThpPhpValue(value: any, isScanOff: any) {
    if (!value) {
      if (isScanOff) {
        return 'Scan Off'
      } else {
        return 'N/A'
      }
    }

    return value.toFixed(0);
  }

  handleFormatDate(dateString: string, withTime: boolean = true) {
    return handleFormatDate(dateString, withTime)
  }

  onSort(sort: any) {
    if (!sort) return;
    this.searchForm.patchValue({
      OrderBy: sort.active,
      OrderDir: sort.direction,
    });

    this.setPage({ offset: 0 });
  }

}
